<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="fm1">
<p class="center"><img alt="" src="OEBPS/images/9780740790430_2-1.jpg"/></p>
<p class="center"><em>Lessons of a Turtle</em> is a wise and warm little book about slowing down and finding your own path in life. It’s a celebration of simplicity, a reminder that the little things in life really are the big things.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740790430_epub_fm1_r1.vue?96ce7406